var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Box",
    { staticClass: "billing" },
    [
      _c("LockUI", { attrs: { show: _vm.submitting } }),
      _c(
        "layoutFormRow",
        { staticClass: "inlineLabel smaller" },
        [
          _c("uiLabel", { attrs: { text: "Credit card" } }),
          _c(
            "Box",
            { attrs: { flex: 1 } },
            [
              _c(
                "UISelect",
                {
                  attrs: { value: _vm.value ? _vm.value.token : null },
                  on: {
                    input: function($event) {
                      _vm.$emit(
                        "input",
                        _vm.cardsOnFileCopy.find(x => x.token == $event)
                      )
                    }
                  }
                },
                [
                  _c("option", { domProps: { value: null } }, [
                    _vm._v("Select a card")
                  ]),
                  _vm._l(_vm.cardsOnFileCopy, function(card) {
                    return _c(
                      "option",
                      { key: card.token, domProps: { value: card.token } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(card.card) +
                            " " +
                            _vm._s(
                              `${String(card.expirationMonth).padStart(2, "0")}`
                            ) +
                            "/" +
                            _vm._s(card.expirationYear) +
                            " " +
                            _vm._s(
                              card.gateway.replace("USAePay", "Fidelity")
                            ) +
                            " "
                        )
                      ]
                    )
                  })
                ],
                2
              ),
              _c("br"),
              _c(
                "span",
                {
                  staticClass: "add-link",
                  on: {
                    click: function($event) {
                      return _vm.dispatch({ type: "setAddingNew" })
                    }
                  }
                },
                [_vm._v("+ or add new card")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: {
            show: _vm.showingAddNew || _vm.submitting,
            top: "100px",
            showCloseText: false,
            requestClose: () => _vm.dispatch({ type: "reset" }),
            width: "600px"
          }
        },
        [
          _c(
            "Box",
            { attrs: { padding: 5 } },
            [
              _c(
                "Box",
                {
                  attrs: {
                    tag: "header",
                    display: "flex",
                    flexAlign: "center",
                    paddingBottom: 3,
                    marginBottom: 2
                  }
                },
                [
                  _c(
                    "layoutText",
                    {
                      attrs: {
                        fontUppercase: "",
                        fontSize: 3,
                        fontWeight: "bold",
                        color: "#222"
                      }
                    },
                    [_vm._v("Add New Credit Card")]
                  )
                ],
                1
              ),
              Object.values(_vm.errors).length > 0
                ? _c(
                    "ul",
                    { staticClass: "error-msg" },
                    _vm._l(Object.values(_vm.errors), function(error) {
                      return _c("li", { key: error }, [_vm._v(_vm._s(error))])
                    }),
                    0
                  )
                : _vm._e(),
              !_vm.form.card || (_vm.form.card && !_vm.form.card.token)
                ? _c(
                    "layoutFormRow",
                    { staticClass: "inlineLabel" },
                    [
                      _c("uiLabel", { attrs: { text: "Card Info" } }),
                      _c(
                        "Box",
                        { staticStyle: { "min-height": "160px" } },
                        [
                          _c("CCwidget", {
                            attrs: {
                              testMode: _vm.testMode,
                              amount: _vm.amount,
                              currency: _vm.currency,
                              gateway: _vm.form.gateway
                            },
                            on: { input: _vm.cardChanged }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "layoutFormRow",
                { staticClass: "inlineLabel" },
                [
                  _c("uiLabel", { attrs: { text: "Bank" } }),
                  _c(
                    "Box",
                    [
                      _c(
                        "UISelect",
                        {
                          staticStyle: { "min-width": "170px" },
                          attrs: { disabled: _vm.form.card },
                          model: {
                            value: _vm.form.gateway,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "gateway", $$v)
                            },
                            expression: "form.gateway"
                          }
                        },
                        [
                          _c(
                            "option",
                            { attrs: { value: "USAePay-Velocity" } },
                            [_vm._v("Main Account")]
                          ),
                          _c(
                            "option",
                            { attrs: { value: "SensePassCardknox" } },
                            [_vm._v("SensePass Cardknox")]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "layoutFormRow",
                { staticClass: "inlineLabel" },
                [
                  _c("uiLabel", { attrs: { text: "Name on card" } }),
                  _c(
                    "Box",
                    { attrs: { flex: 1, marginRight: 1 } },
                    [
                      _c("UIInput", {
                        attrs: { placeholder: "First Name" },
                        model: {
                          value: _vm.form.firstName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "firstName", $$v)
                          },
                          expression: "form.firstName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "Box",
                    { attrs: { flex: 1 } },
                    [
                      _c("UIInput", {
                        attrs: { placeholder: "Last Name" },
                        model: {
                          value: _vm.form.lastName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "lastName", $$v)
                          },
                          expression: "form.lastName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "layoutFormRow",
                { staticClass: "inlineLabel smaller" },
                [
                  _c("uiLabel", { attrs: { text: "Address" } }),
                  _c(
                    "Box",
                    { attrs: { flex: 2, marginRight: 2 } },
                    [
                      _c("UIInput", {
                        attrs: { placeholder: "Street" },
                        model: {
                          value: _vm.form.street,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "street", $$v)
                          },
                          expression: "form.street"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "Box",
                    { attrs: { flex: 1 } },
                    [
                      _c("UIInput", {
                        attrs: { placeholder: "Apt" },
                        model: {
                          value: _vm.form.street2,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "street2", $$v)
                          },
                          expression: "form.street2"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "layoutFormRow",
                { staticClass: "inlineLabel smaller" },
                [
                  _c("uiLabel", { attrs: { text: "City/State/Zip" } }),
                  _c(
                    "Box",
                    { attrs: { flex: 2, marginRight: 1 } },
                    [
                      _c("UIInput", {
                        attrs: { placeholder: "City" },
                        model: {
                          value: _vm.form.city,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "city", $$v)
                          },
                          expression: "form.city"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "Box",
                    { attrs: { flex: 1, marginRight: 1 } },
                    [
                      _c("UIInput", {
                        attrs: { placeholder: "State" },
                        model: {
                          value: _vm.form.state,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "state", $$v)
                          },
                          expression: "form.state"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "Box",
                    { attrs: { flex: 1 } },
                    [
                      _c("UIInput", {
                        attrs: { placeholder: "Zip" },
                        model: {
                          value: _vm.form.zipCode,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "zipCode", $$v)
                          },
                          expression: "form.zipCode"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "layoutFormRow",
                { staticClass: "inlineLabel" },
                [
                  _c("uiLabel", { attrs: { text: " " } }),
                  _c(
                    "UIButton",
                    {
                      staticStyle: { "margin-right": "10px" },
                      on: { click: _vm.submit }
                    },
                    [
                      _vm._v("Submit "),
                      _vm.submitting
                        ? _c("Icon", { attrs: { name: "spinner", spin: "" } })
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "UIButton",
                    {
                      staticClass: "inverted",
                      on: {
                        click: function($event) {
                          return _vm.dispatch({ type: "reset" })
                        }
                      }
                    },
                    [_vm._v("Cancel")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }